var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideShowColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.84667 5.27094C2.23197 3.19808 5.13594 0 9.86738 0C14.5988 0 17.5028 3.19808 18.8881 5.27094C19.353 5.96655 19.5854 6.31435 19.5643 6.95691C19.5431 7.59948 19.2763 7.94688 18.7426 8.64168C17.1535 10.7107 13.9803 14 9.86738 14C5.75443 14 2.58127 10.7107 0.992141 8.64168C0.458494 7.94688 0.19167 7.59948 0.170515 6.95691C0.149359 6.31435 0.381796 5.96655 0.84667 5.27094ZM9.86738 11C12.0765 11 13.8674 9.20914 13.8674 7C13.8674 4.79086 12.0765 3 9.86738 3C7.65824 3 5.86738 4.79086 5.86738 7C5.86738 9.20914 7.65824 11 9.86738 11Z",
    fill: "#0376EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideShowColor);
export default __webpack_public_path__ + "static/media/hide_show_color.d34acc89ff5ba14b0f64d70d9f6fbd5a.svg";
export { ForwardRef as ReactComponent };